import React from 'react'
import { FormattedNumber } from 'react-intl'
import { DEFAULT_CURRENCY_CODE } from 'lib/core/resources/constants' // TODO: get from store config (redux)?

interface Props {
  currency?: string
  value: number
}

export const Price = ({ value, currency = DEFAULT_CURRENCY_CODE }: Props) => {
  return (
    <FormattedNumber
      value={value}
      style='currency' // eslint-disable-line
      currency={currency}
    />
  )
}
